export default {
  title: 'Plantillas',

  labels: {
    id: 'ID',
    title: 'Título',
    type: 'Tipo',
    owner: 'Propietario',
    text: 'Texto',
    isActive: 'Activo'
  },

  buttons: {
    create: 'Crear plantilla',
    apply: 'Aplicar'
  },
  links: { edit: 'Editar plantilla' },
  dialogs: { create: 'Nombre su plantilla' },

  contents: {
    confirm: {
      remove: '¿Está seguro de que desea eliminar la plantilla {title}?'
    }
  },

  hints: {
    sendername: 'Nombre del remitente: {sendername}',
    text: 'Texto: {text}'
  },

  tooltips: {
    isActive: 'Activar o desactivar la plantilla.',
    type: 'Tipo: {type}',
    sender: 'Nombre del remitente: {sender}',
    text: 'Texto: {text}'
  },

  snackbars: {
    created: 'Plantilla creada con éxito.',
    updated: 'Plantilla actualizada con éxito.',
    removed: 'Plantilla eliminada con éxito.'
  }
}
